/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiNexpro } from '@shared/config';

export interface IGetUserInfo {
  id: string;
  personId: string;
  subId: string;
  displayName: string;
  avatarUrl: string;
  email: string;
  userType: string;
  lastUpdatedPassword: string;
  status: string;
  termOfUseAcceptedDate: string;
  termOfUseAcceptedIP: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  UserPreference: IUserPreference[];
  Person: IPerson;
  UserCompany: IUserCompany[];
  Driver: any[];
  isTermAccepted: boolean;
}

export interface IUserPreference {
  preferredCompanyId: any;
  preferredModuleKey: any;
}

export interface IPerson {
  name: string;
  socialName: string;
  documentNumber: string;
  genre: string;
  birthDate: any;
  phones: string[];
  emails: string[];
  documentsMetadata: any;
  addressMetadata: any;
}

export interface IUserCompany {
  accountId: string;
  companyId: string;
  role: string;
  status: string;
  startDate: string;
  endDate: any;
  Company: ICompany;
}

export interface ICompany {
  companyName: string;
  apiKey: string;
  logoUrl: any;
  displayName: string;
  documentNumber: string;
  addressMetadata: IAddressMetadata;
  phones: string[];
  tag: string[];
  status: string;
  startDate: string;
  endDate: string;
  isActive: boolean;
  CompanyModule: ICompanyModule[];
  ownerId: string;
  User: IUser;
}

export interface IAddressMetadata {
  city?: string;
  state?: string;
  street?: string;
  country?: string;
  zipCode?: string;
  complement?: string;
  neighborhood?: string;
  streetNumber?: string;
  rua?: string;
  numero?: number;
}

export interface ICompanyModule {
  moduleId: string;
  sourceKey: string;
  moduleKey: string;
  status: string;
  hasApiAccess: boolean;
  startDate: string;
  endDate: any;
  Module: IModule;
}

export interface IModule {
  title: string;
  description: string;
  hasApi: boolean;
  companyIdentification: string;
  vehicleIdentification: string;
  driverIdentification: string;
  logoUrl: string;
  metadata: IMetadata;
}

export interface IMetadata {
  backgroundCardUrl: string;
}

export interface IUser {
  personId: string;
  displayName: string;
  email: string;
  userType: string;
  Person: IPerson2;
}

export interface IPerson2 {
  name: string;
  socialName: string;
  documentNumber: string;
  genre: string;
  birthDate: any;
  phones: string[];
}

export async function getUserInfo() {
  return apiNexpro.get<IGetUserInfo>(`/user/get-user-info`);
}
